module.exports = __webpack_public_path__ + "static/media/btn_right-wrong.d846e1ff.png";